/* eslint-disable react/prop-types */
import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
  Paper,
  Typography,
} from '@material-ui/core';
import { Check, Clear } from '@material-ui/icons';

const StudentNeedsDialog = ({ student }) => (
  <div style={{ width: '100%' }}>
    <TableContainer style={{ marginBottom: '10px' }}>
      <Table>
        <TableHead style={{ backgroundColor: '#DADFEA' }}>
          <TableRow>
            <TableCell colSpan={10} align="center">Professional/technical vocabulary</TableCell>
          </TableRow>
          <TableRow>
            {/* // type of language */}
            <TableCell>logistics</TableCell>
            <TableCell>sales</TableCell>
            <TableCell>marketing</TableCell>
            <TableCell>finance</TableCell>
            <TableCell>legal</TableCell>
            <TableCell>engineering</TableCell>
            <TableCell>production</TableCell>
            <TableCell>quality</TableCell>
            <TableCell>it</TableCell>
            <TableCell>hr</TableCell>
            <TableCell>other</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{student?.needs?.logistics ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.sales ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.marketing ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.finance ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.legal ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.engineering ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.production ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.quality ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.it ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.hr ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.otherPro ? student.needs.otherProText : <Clear color="error" />}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    <TableContainer style={{ marginBottom: '10px' }}>
      <Table>
        <TableHead style={{ backgroundColor: '#DADFEA' }}>
          <TableRow>
            <TableCell colSpan={9} align="center">General vocabulary</TableCell>
          </TableRow>
          <TableRow>
            {/* // type of language */}
            <TableCell>news</TableCell>
            <TableCell>environment</TableCell>
            <TableCell>economy</TableCell>
            <TableCell>politics</TableCell>
            <TableCell>art</TableCell>
            <TableCell>sport</TableCell>
            <TableCell>travelling</TableCell>
            <TableCell>education</TableCell>
            <TableCell>leisure</TableCell>
            <TableCell>other</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{student?.needs?.news ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.environment ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.economy ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.politics ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.art ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.sport ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.travelling ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.education ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.leisure ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.otherVoc ? student.needs.otherVocText : <Clear color="error" />}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    <TableContainer style={{ marginBottom: '10px' }}>
      <Table>
        <TableHead style={{ backgroundColor: '#DADFEA' }}>
          <TableRow>
            <TableCell colSpan={6} align="center">Professional skills</TableCell>
          </TableRow>
          <TableRow>
            {/* // type of language */}
            <TableCell>meetings</TableCell>
            <TableCell>presentations</TableCell>
            <TableCell>negotiations</TableCell>
            <TableCell>emails</TableCell>
            <TableCell>telephoning</TableCell>
            <TableCell>other</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{student?.needs?.meetings ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.presentations ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.negotiations ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.emails ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>{student?.needs?.telephoning ? <Check style={{ color: '#5DC27B' }} /> : <Clear color="error" />}</TableCell>
            <TableCell>
              {student?.needs?.otherWorksRelated
                ? student.needs.otherWorksRelatedText
                : <Clear color="error" />}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    <Paper
      style={{
        padding: '20px',
      }}
    >
      <Typography
        variant="subtitle2"
        style={{
          marginBottom: '20px',
        }}
      >
        Objective(s):
      </Typography>
      <Typography
        variant="body2"
      >
        {student.needs?.objectives ? student.needs.objectives : 'No objective(s) given'}
      </Typography>
    </Paper>
    <Divider />
  </div>
);

export default StudentNeedsDialog;
